import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
import Page from 'lib-knowledge-utils/components/page/index';
import { ReactNode } from 'react';

import { useManagementLanguages } from '../hooks/useManagementLanguages';
import { LanguageContext, useLangParam } from './language';

export const LanguageContextProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [currentLanguage, setCurrentLanguage] = useLangParam();
  const { data, loading, error } = useManagementLanguages({
    selectedLanguageId: currentLanguage,
    fetchPolicy: 'cache-and-network',
  });

  if (error) throw error;

  if (loading || !data) {
    return (
      <Page>
        <FlexBox
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Spinner size={64} />
        </FlexBox>
      </Page>
    );
  }

  // Include selectedLanguageId in the value passed to the provider
  return (
    <LanguageContext.Provider
      value={{
        ...data,
        currentLanguage,
        setCurrentLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
